import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Badge from 'react-bootstrap/Badge';
import DetailRequest from "../../magData/Bus/DetailRequest";
import DetailResponse from "../../magData/Bus/DetailResponse";

function BusDetailPage() {

  return (
    <>

      <Container fluid >
        <Row>
          <Col sm={12} >
            <p className="page-title">Bus Detail Method</p>
          </Col>
          <Col sm={12} >
            <p>EndPoint : https://gdscpapi.parsgds.com/gateway/bus/detail</p>
          </Col>
          <Col sm={12} >
            <p> type : json (default)</p>
          </Col>
        </Row>
        <Row>
          <Col sm={12} >
            <p>Body Parameters</p>
          </Col>
          <Col sm={12} >

            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>searchKey</td>
                  <td>Search Key</td>
                  <td>Guid </td>
                  <td><Badge bg="warning" text="dark">
                    Required
                  </Badge></td>
                </tr>
                <tr>
                  <td>gdsRefrenceID</td>
                  <td>Refrence ID</td>
                  <td>Guid </td>
                  <td><Badge bg="warning" text="dark">
                    Required
                  </Badge></td>
                </tr>
              </tbody>
            </Table>
          </Col>

        </Row>
        <Row>
          <Col sm={12}><span className="code-section-title">Request Formats - application/json, text/json</span></Col>
          <Col sm={12}>

            <pre className="code-section">
              {JSON.stringify(DetailRequest, null, 2)}
            </pre>
          </Col>
        </Row>

        {/* Response  */}
        <Row>
          <Col sm={12} >
            <p>Response Information</p>
          </Col>
          <Col sm={12} >

            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>success</td>
                  <td>success</td>
                  <td>boolean </td>
                  <td>None.</td>
                </tr>
                <tr>
                  <td>gdsRefrenceID</td>
                  <td>Refrence ID</td>
                  <td>Guid </td>
                  <td></td>
                </tr>
                <tr>
                  <td>token</td>
                  <td>
                    token
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>busId</td>
                  <td>
                    busId
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>company</td>
                  <td>
                    company
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>operatingCompany</td>
                  <td>
                    operatingCompany
                  </td>
                  <td>String</td>
                  <td>
                    <p>Collection of string</p>
                  </td>
                </tr>
                <tr>
                  <td colSpan={4}>
                    <Table bordered>
                      <tbody>
                        <tr>
                          <td>code</td>
                          <td>
                            code
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>name</td>
                          <td>
                            name
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>
                <tr>
                  <td>boardingPoint</td>
                  <td>
                    boardingPoint
                  </td>
                  <td>Collection of string</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td colSpan={4}>
                    <Table bordered>
                      <tbody>
                        <tr>
                          <td>city</td>
                          <td>
                            city
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>terminal</td>
                          <td>
                            terminal
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>additionalInfo</td>
                          <td>
                            additionalInfo
                          </td>
                          <td>Collection of string</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={4}>
                            <Table bordered>
                              <tbody>
                                <tr>
                                  <td>city</td>
                                  <td>
                                    city
                                  </td>
                                  <td>Collection of string</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={4}>
                                    <Table bordered>
                                      <tbody>
                                        <tr>
                                          <td>id</td>
                                          <td>
                                            id
                                          </td>
                                          <td>String</td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>name</td>
                                          <td>
                                            name
                                          </td>
                                          <td>String</td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>englishName</td>
                                          <td>
                                            englishName
                                          </td>
                                          <td>String</td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </Table>
                                  </td>
                                </tr>
                                <tr>
                                  <td>name</td>
                                  <td>
                                    name
                                  </td>
                                  <td>String</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>englishName</td>
                                  <td>
                                    englishName
                                  </td>
                                  <td>String</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>
                <tr>
                  <td>droppingPoints</td>
                  <td>
                    droppingPoints
                  </td>
                  <td>Collection of string</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td colSpan={4}>
                    <Table bordered>
                      <tbody>
                        <tr>
                          <td>city</td>
                          <td>
                            city
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>terminal</td>
                          <td>
                            terminal
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>additionalInfo</td>
                          <td>
                            additionalInfo
                          </td>
                          <td>Collection of string</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={4}>
                            <Table bordered>
                              <tbody>
                                <tr>
                                  <td>city</td>
                                  <td>
                                    city
                                  </td>
                                  <td>Collection of string</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={4}>
                                    <Table bordered>
                                      <tbody>
                                        <tr>
                                          <td>id</td>
                                          <td>
                                            id
                                          </td>
                                          <td>String</td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>name</td>
                                          <td>
                                            name
                                          </td>
                                          <td>String</td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>englishName</td>
                                          <td>
                                            englishName
                                          </td>
                                          <td>String</td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </Table>
                                  </td>
                                </tr>
                                <tr>
                                  <td>name</td>
                                  <td>
                                    name
                                  </td>
                                  <td>String</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>englishName</td>
                                  <td>
                                    englishName
                                  </td>
                                  <td>String</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>
                <tr>
                  <td>type</td>
                  <td>
                    type
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>price</td>
                  <td>
                    price
                  </td>
                  <td>Integer</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>commissionPercentage</td>
                  <td>
                    commissionPercentage
                  </td>
                  <td>Integer</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>financial</td>
                  <td>
                    financial
                  </td>
                  <td>Collection of string</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td colSpan={4}>
                    <Table bordered>
                      <tbody>
                        <tr>
                          <td>price</td>
                          <td>
                            price
                          </td>
                          <td>Integer</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>maxApplicableDiscountPercentage</td>
                          <td>
                            maxApplicableDiscountPercentage
                          </td>
                          <td>Integer</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>availablePaymentMethods</td>
                          <td>
                            availablePaymentMethods
                          </td>
                          <td>Collection of string</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>commissionPercentage</td>
                          <td>
                            commissionPercentage
                          </td>
                          <td>Integer</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>
                <tr>
                  <td>departureDate</td>
                  <td>
                    departureDate
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>availableSeates</td>
                  <td>
                    availableSeates
                  </td>
                  <td>Integer</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>status</td>
                  <td>
                    status
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>seates</td>
                  <td>
                    seates
                  </td>
                  <td>Collection of string</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td colSpan={4}>
                    <Table bordered>
                      <tbody>
                        <tr>
                          <td>number</td>
                          <td>
                            number
                          </td>
                          <td>Integer</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>column</td>
                          <td>
                            column
                          </td>
                          <td>Integer</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>row</td>
                          <td>
                            row
                          </td>
                          <td>Integer</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>status</td>
                          <td>
                            status
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>
                <tr>
                  <td>description</td>
                  <td>
                    description
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col sm={12}><span className="code-section-title">Response Formats - application/json, text/json</span></Col>
          <Col sm={12}>

            <pre className="code-section">
              {JSON.stringify(DetailResponse, null, 2)}
            </pre>


          </Col>
        </Row>
      </Container>

    </>
  );
}

export default BusDetailPage;